import './_iconButton.scss'

interface IconButtonProps {
    icon: string | JSX.Element | JSX.Element[]
    clickFn?: any
    desc?: string
    input?: any
    type?: string
    size?: string
    customClass?: string
    disabled?: boolean
    customSizePx?: number
}

export const IconButton = ({
    icon,
    clickFn,
    desc,
    input,
    type,
    size,
    customClass,
    disabled = false,
    customSizePx,

}: IconButtonProps) => {

    const style = {
        cursor: clickFn ? 'pointer' : 'default',
        ...(customSizePx
            ? {
                width: `${customSizePx}px`,
                height: `${customSizePx}px`,
                minWidth: `${customSizePx}px`,
                minHeight: `${customSizePx}px`,
                maxWidth: `${customSizePx}px`,
                maxHeight: `${customSizePx}px`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
            }
            : {}),
    };

    return (
        <div
            className={`${disabled ? 'disabled' : ''} iconbutton${
                type ? ` iconbutton--${type}` : ''
            }${customClass ? ` ${customClass}` : ''}${
                size ? ` iconbutton--${size}` : ''
            }`}
            style={style}
            onClick={(e: React.MouseEvent<HTMLElement>) => {
                clickFn && e.stopPropagation()
                clickFn?.()
            }}
        >
            {typeof icon === 'string'
                ? <img src={icon} alt={desc} style={customSizePx ? { width: customSizePx, height: customSizePx } : {}} />
                : icon}

            {input || ''}
        </div>
    )
}

